import footerStyles from './Footer.module.scss';
import logo from '../../../assets/images/logo.png';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '../constants';

const legalLinks = [
  { href: '/privacy-policy', label: 'Privacy Policy' },
  { href: '/terms-of-service', label: 'Terms of Service' },
];

const Footer = () => {
  const location = useLocation();

  const handleNavClick = (e, to, section) => {
    if (to === '/' && location.pathname === '/') {
      e.preventDefault();
      if (window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    if (location.pathname === to && section) {
      e.preventDefault();
      const el = document.getElementById(section);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className={footerStyles.footer} role="contentinfo">
      <div className={footerStyles.footerContent}>
        <div className={footerStyles.footerInfo}>
          <div className={footerStyles.logoContainer}>
            <img className={footerStyles.footerLogo} src={logo} alt="mobiyo" />
            <h3>mobiyo</h3>
          </div>
          <div>
            <p>Collect your mobile app reviews and analyze with AI</p>
          </div>
        </div>
        <div className={footerStyles.footerLinks}>
          <nav className={footerStyles.footerLinkGroup} aria-label="Company">
            <h4>Company</h4>
            <ul>
              {navLinks.map(link => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={e => handleNavClick(e, link.to, link.section)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav className={footerStyles.footerLinkGroup} aria-label="Legal">
            <h4>Legal</h4>
            <ul>
              {legalLinks.map(link => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </nav>
          {/* <div className={footerStyles.footerLinkGroup}>
            <h4>Connect</h4>
            <a href="https://linkedin.com/company/mobiyo" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
            </a>
            <a href="https://twitter.com/mobiyo" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} /> Twitter
            </a>
            <a href="https://instagram.com/mobiyo" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} /> Instagram
            </a>
          </div> */}
        </div>
      </div>
      <div className={footerStyles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} mobiyo. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 
